"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Users, TrendingUp, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyRestaurantsChooseUs() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const benefits = [{
    icon: Users,
    title: "Build Loyal Customer Relationships",
    description: "Transform one-time diners into repeat patrons through personalized email campaigns that keep your restaurant top-of-mind."
  }, {
    icon: TrendingUp,
    title: "Boost Revenue & ROI",
    description: "Drive measurable results with data-driven strategies that increase reservations, repeat visits, and direct revenue without third-party commissions."
  }, {
    icon: Shield,
    title: "Seamless Integration & Support",
    description: "Effortlessly connect with your existing reservation and POS systems while our expert team handles the technical details."
  }];
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section className="bg-background py-20 px-6">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-display text-center text-4xl font-bold text-foreground mb-4">
          Why Restaurants Choose Us
        </h2>
        <p className="text-center text-muted-foreground text-lg mb-16 max-w-2xl mx-auto">
          We specialize in helping restaurants grow their email lists and turn subscribers into loyal customers
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-[var(--duration-fast)] ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full text-center shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] hover:-translate-y-1">
                  <CardContent className="flex flex-col items-center gap-4 pt-8">
                    <div className="flex items-center justify-center w-16 h-16 rounded-lg bg-primary/10 text-primary transition-transform duration-[var(--duration-medium)] hover:scale-110">
                      <Icon className="w-8 h-8" />
                    </div>
                    <h3 className="font-display text-xl font-semibold text-foreground">
                      {benefit.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {benefit.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}